import ContactInfoEditForm from "PFApp/profiles/common/contact_info_edit_form";
import ProfileEditPanel from "PFApp/profiles/edit/profile_edit_panel";
import { getProfileSectionText } from "PFApp/profiles/edit/profile_edit_section_titles";
import { RouterPrompt } from "PFComponents/router_prompt/router_prompt";
import { isProfileFieldPermitted } from "PFCore/helpers/profile_permissions";
import { AccessLevel, CurrentProfile, Profile } from "PFTypes";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";

type ContactInformationSectionProps = {
  profile: Profile;
  currentProfile: CurrentProfile;
  adminPage: boolean;
  handleProfileUpdate: () => void;
};

export const ContactInformationSection = ({
  profile,
  currentProfile,
  adminPage,
  handleProfileUpdate
}: ContactInformationSectionProps) => {
  const { t } = useTranslation("profiles", { keyPrefix: "edit.sections" });
  const [onLoading, setOnLoading] = useState(false);
  const [hasChanged, setHasChanged] = useState(false);

  const onChanged = (changed: boolean) => {
    setHasChanged(changed);
    handleProfileUpdate();
  };

  const isPermitted = isProfileFieldPermitted(
    currentProfile?.permissionsGroup,
    profile?.permissionsGroup?.id,
    "contactInfo",
    AccessLevel.ReadWrite
  );

  const contactInfoRef = useRef<{ onAddNew: VoidFunction }>(null);

  const buttonDisabled = !isPermitted ? !isPermitted : adminPage ? false : onLoading;

  return (
    <ProfileEditPanel
      title={getProfileSectionText("contact_information")}
      headingButtonLabel={t("contactInfo.addNew")}
      handleHeadingButtonClick={() => contactInfoRef?.current?.onAddNew()}
      headingButtonDisabled={buttonDisabled}
    >
      <RouterPrompt when={hasChanged} />
      <ContactInfoEditForm
        profile={profile}
        adminPage={adminPage}
        ref={contactInfoRef}
        onLoading={setOnLoading}
        onChanged={onChanged}
      />
    </ProfileEditPanel>
  );
};
